// Espelho de encurtador-lambda/src/utils/validators.py.
// Mantenha as constantes e regex em sincronia.

export const LINK_MAX = 2048;
export const NOME_MAX = 80;
export const NOME_MIN = 1;
export const SLUG_REGEX = /^[a-zA-Z0-9_-]{3,30}$/;
const SCHEMES_VALIDOS = new Set(['http:', 'https:']);

export function validarLink(link) {
  if (typeof link !== 'string') return 'link_obrigatorio';
  const v = link.trim();
  if (!v) return 'link_obrigatorio';
  if (v.length > LINK_MAX) return 'link_longo';
  if (/[\r\n\t]/.test(v)) return 'link_invalido';
  let parsed;
  try {
    parsed = new URL(v);
  } catch {
    return 'link_invalido';
  }
  if (!SCHEMES_VALIDOS.has(parsed.protocol)) return 'link_scheme_invalido';
  if (!parsed.hostname) return 'link_invalido';
  return null;
}

export function validarNome(nome) {
  if (typeof nome !== 'string') return 'nome_obrigatorio';
  const v = nome.trim();
  if (v.length < NOME_MIN) return 'nome_obrigatorio';
  if (v.length > NOME_MAX) return 'nome_longo';
  if (v.includes('<') || v.includes('>')) return 'nome_caracteres_invalidos';
  return null;
}

export function validarNomeOpcional(nome) {
  if (nome == null || (typeof nome === 'string' && nome.trim() === '')) return null;
  return validarNome(nome);
}

export function validarSlug(slug) {
  if (slug == null || slug === '') return null;
  if (typeof slug !== 'string') return 'slug_invalido';
  if (!SLUG_REGEX.test(slug)) return 'slug_invalido';
  return null;
}

export const MENSAGENS_ERRO = {
  link_obrigatorio: 'Informe um link.',
  link_longo: `O link não pode ultrapassar ${LINK_MAX} caracteres.`,
  link_invalido: 'O link informado é inválido.',
  link_scheme_invalido: 'O link precisa começar com http:// ou https://',
  nome_obrigatorio: 'Informe um nome para o link.',
  nome_longo: `O nome não pode ultrapassar ${NOME_MAX} caracteres.`,
  nome_caracteres_invalidos: 'O nome contém caracteres não permitidos.',
  slug_invalido: 'O nome personalizado deve ter de 3 a 30 caracteres alfanuméricos, _ ou -.',
  slug_em_uso: 'Esse nome personalizado já está em uso.',
  plano_insuficiente: 'Nome personalizado é exclusivo do Plano Pro.',
  nao_autenticado: 'Faça login para continuar.',
  origem_invalida: 'Origem da requisição não permitida.',
  erro_interno: 'Algo deu errado. Tente novamente.',
};
